module.exports = __webpack_public_path__ + "static/img/gamelist15.21c314cb.png";